export const APPOINTMENT_CAROUSEL = {
  loading: {
    title: 'Hang in there',
    subtitle: "We're gathering your appointments."
  },
  error: {
    title: "We couldn't find your info",
    subtitle: "We're sorry, your appointments are unavailable at the moment."
  },
  empty: {
    title: 'You have no upcoming appointments',
    button: 'Book an Appointment'
  }
};
